import { ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS } from "@faire/web--source/common/consts/ISO_TO_COUNTRY_NAME";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

export const countryDisplayNameFromIso = (
  iso: string,
  strictLocalize: StrictLocalizeFunction
): string => {
  if (iso === "USA") {
    return iso;
  }

  // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
  return ISO_TO_COUNTRY_NAME_WITHOUT_SANCTIONS(strictLocalize)[iso] ?? iso;
};
